<template>
  <div class="buybox-purchase-info__paymethods" v-if="!product.title.includes('E-Gift Card')">
    <span class="buybox-purchase-info__paymethods-inline-container">
      <span class="buybox-purchase-info__paymethods-text" v-if="isAboveThreshold">
        Pay in {{ totalEMI }} interest-free payments with
      </span>

      <svg class="afterpay-image" role="img" aria-label="Afterpay image">
        <use href="#afterpay-new-pdp"></use>
      </svg>
      <span class="buybox-purchase-info__paymethods-separator">or</span>
      <svg class="klarna-image" role="img" aria-label="Klarna image">
        <use href="#klarna-new-pdp"></use>
      </svg>

      <span class="buybox-purchase-info__paymethods-text" v-if="!isAboveThreshold">
        available for orders over $35.
      </span>

      <a class="buybox-purchase-info__paymethods-learn-more" :href="generateBNPLpageURL()" target="_blank">Learn more</a>
    </span>
  </div>
</template>

<script setup>
  import { computed, toRefs } from 'vue';
  
  const props = defineProps({
    product: Object,
    productForm: Object,
  });

  const totalEMI = 4;
  
  const { product, productForm } = toRefs(props);

  const amountEMI = computed(() => {
    const price = productForm.value?.selectedVariant?.price || product.value?.price;
    return window.formattedPrice((price/totalEMI)/100);
  });

  const isAboveThreshold = computed(() => {
    const variantPrice = productForm.value?.selectedVariant?.price;
    const basePrice = product.value?.price;
    return variantPrice > 3500 || basePrice > 3500;
  });

  const generateBNPLpageURL = () => {
    return window.location.origin + '/pages/bnpl';
  };
</script>
